var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTxnClaimV1 = function SvgTxnClaimV1(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Claim"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.29,22.85V35.67c0,.21-.07.45.13.62,0,.32-.24.46-.43.63a8.43,8.43,0,0,0-2.71,6.48c0,2.08,0,4.16,0,6.24,0,.35.08.72-.24,1a2,2,0,0,1-.91.12H34.89c-1,0-1,0-1,1s0,2,0,3q0,2.13,0,4.26c0,1.16,0,2.33,0,3.5a1.08,1.08,0,0,1-.19.76q-15.69,0-31.38,0c-.67,0-.63-.34-.63-.79q0-26.66,0-53.3c0-2.38,0-4.75,0-7.13,0-.42.06-.64.57-.64H42.11c0,.3-.32.27-.52.3A10.26,10.26,0,0,0,36,4.59a10.35,10.35,0,0,0-3.09,5.9,8.54,8.54,0,0,0-.15,1.25c0,.22,0,.44-.29.55a3,3,0,0,1-1,.08h-7.7a4.24,4.24,0,0,0-.87.05.78.78,0,0,0-.71.82.79.79,0,0,0,.73.81,4.1,4.1,0,0,0,.86,0h8a1.61,1.61,0,0,1,1.09.21,3.41,3.41,0,0,1,.58,2.11c-.32.29-.71.21-1.08.22h-8.6a3.15,3.15,0,0,0-.92.07.78.78,0,0,0-.63.83.76.76,0,0,0,.64.75,3.54,3.54,0,0,0,.92.07h9.73a5.38,5.38,0,0,1,1.06.05,1.63,1.63,0,0,1,.78.59,10.53,10.53,0,0,0,7.26,3.65C42.86,22.68,43.12,22.62,43.29,22.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.29,22.85a10.85,10.85,0,0,1-8.55-4.28,3.67,3.67,0,0,1-1.31-2.27l-.56-1.87a2.47,2.47,0,0,1-.26-2.27,10.58,10.58,0,0,1,2.9-7.28,10.33,10.33,0,0,1,6.16-3.24c.15,0,.31,0,.44-.12a11.24,11.24,0,0,1,7.48,2.05,10.68,10.68,0,0,1-6.3,19.28Z",
    style: {
      fill: "#87c690"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.77,63.34h-4.3a1.06,1.06,0,0,1-.19-.75c0-1.17,0-2.34,0-3.5,0-1.42,0-2.84,0-4.26,0-1.19,0-2.37,0-3.55a1.3,1.3,0,0,1,.14-.7.64.64,0,0,1,.46-.21c.93,0,1.86,0,2.79,0a1.77,1.77,0,0,1,1.13.19,1.15,1.15,0,0,1,.16.7c0,1.19,0,2.38,0,3.57,0,1.42,0,2.84,0,4.27,0,1.16,0,2.33,0,3.5A1.08,1.08,0,0,1,50.77,63.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.77,54.81l0-4.24a1,1,0,0,1,.8-.23c.71,0,1.41,0,2.12,0,1,0,2,0,3.06,0a5.61,5.61,0,0,1,2.27.18l4.52,0v4.26a1.12,1.12,0,0,1-.88.22h-11A1.16,1.16,0,0,1,50.77,54.81Z",
    style: {
      fill: "#75aa7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.77,54.81H63.52v4.27a1.11,1.11,0,0,1-.88.21h-11a1.17,1.17,0,0,1-.88-.21Z",
    style: {
      fill: "#87c690"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.47,59.08v4.26H33.71V59.08a1.16,1.16,0,0,1,.88-.21h11A1.16,1.16,0,0,1,46.47,59.08Z",
    style: {
      fill: "#75aa7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.77,59.08H63.52c0,1.24,0,2.48,0,3.72,0,.45-.14.55-.57.55-4.07,0-8.15,0-12.22,0Z",
    style: {
      fill: "#75aa7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.49,31.36H6.37a3,3,0,0,1-.6,0,1.07,1.07,0,0,1,0-2.1,2.35,2.35,0,0,1,.53,0H38.69a3.11,3.11,0,0,1,.53,0,1,1,0,0,1,.87,1.09,1,1,0,0,1-.89,1,2.89,2.89,0,0,1-.59,0Z",
    style: {
      fill: "#1b5998"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.45,35.62H6.4a4.68,4.68,0,0,1-.53,0,1.07,1.07,0,0,1,0-2.13c.15,0,.31,0,.46,0h32.3a3.69,3.69,0,0,1,.47,0,1.06,1.06,0,0,1,0,2.12c-.18,0-.36,0-.53,0Z",
    style: {
      fill: "#1b5998"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.83,27.09H6.38a4,4,0,0,1-.6,0A1,1,0,0,1,4.91,26a1,1,0,0,1,.87-1,2.35,2.35,0,0,1,.53,0H35.48A4.64,4.64,0,0,1,36,25a1,1,0,0,1,.88,1.09,1,1,0,0,1-.88,1,2.9,2.9,0,0,1-.59,0Z",
    style: {
      fill: "#1b5998"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.84,39.89H6.39a4,4,0,0,1-.6,0,1.07,1.07,0,0,1,0-2.1,2.43,2.43,0,0,1,.54,0H35.47a3.25,3.25,0,0,1,.54,0,1,1,0,0,1,.88,1.08,1,1,0,0,1-.87,1,3,3,0,0,1-.6,0Z",
    style: {
      fill: "#1b5998"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9,44.15H6.39a4,4,0,0,1-.6,0,1,1,0,0,1-.88-1.08,1,1,0,0,1,.87-1,2.33,2.33,0,0,1,.53,0H35.48A4.73,4.73,0,0,1,36,42a1,1,0,0,1,.88,1.08,1,1,0,0,1-.87,1,3,3,0,0,1-.6,0Z",
    style: {
      fill: "#1b5998"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.14,49.32c-.63.64-1.17,1.22-1.73,1.79-.81.8-1.54.68-2.05-.32-.41-.81-.46-.87-1.15-.3a4.72,4.72,0,0,1-3.74,1.14c-.5-.07-1,0-1.53,0a1,1,0,0,1-1-1.07,1,1,0,0,1,1-1.06h.2a6,6,0,0,0,5.07-1.57,1.93,1.93,0,0,1,1-.55,1.12,1.12,0,0,1,1.27.84c.16.43.33.51.68.13.52-.57,1.08-1.11,1.64-1.65a1.09,1.09,0,0,1,1.92.47c.2.59.41,1.17.58,1.77a.69.69,0,0,0,.81.57c2.66,0,5.32,0,8,0a1.16,1.16,0,0,1,1.14.52,1.07,1.07,0,0,1-1.06,1.61H19.3C16.53,51.62,17.05,51.79,16.14,49.32Z",
    style: {
      fill: "#5e80e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.49,50.57l0,4.24a1.17,1.17,0,0,1-.88.22h-11a1.17,1.17,0,0,1-.88-.22c0-1.24,0-2.48,0-3.71,0-.45.14-.56.57-.56,1.94,0,3.89,0,5.83,0h4.56A1.93,1.93,0,0,1,46.49,50.57Z",
    style: {
      fill: "#75aa7d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.09,
    cy: 56.95,
    rx: 9.02,
    ry: 3.02,
    style: {
      fill: "#87c690"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.43,16.3a17.12,17.12,0,0,0,1.31,2.27H23.64c-.16,0-.31,0-.47,0-.78,0-1.22-.41-1.2-1.09s.45-1,1.2-1h9.5C32.93,16.43,33.21,16.53,33.43,16.3Z",
    style: {
      fill: "#1b5998"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.61,12.16a11.53,11.53,0,0,0,.26,2.27A1.36,1.36,0,0,0,32,14.3H23.18a1.08,1.08,0,0,1-1.1-.58,1,1,0,0,1,.05-1.07,1.15,1.15,0,0,1,1.1-.49Z",
    style: {
      fill: "#1b5998"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.13,16.43a1.14,1.14,0,0,1-.82-.39c-.66-.66-1.32-1.31-2-2a1.07,1.07,0,0,1-.06-1.59,1.09,1.09,0,0,1,1.55,0,.43.43,0,0,0,.1.09c.43.37.76,1.13,1.26,1.06S42,13,42.44,12.56c1.42-1.41,2.82-2.83,4.24-4.23a1.08,1.08,0,1,1,1.58,1.45L42,16.08A1.09,1.09,0,0,1,41.13,16.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.76,48.12c-.27.33-.71.65-.75,1s.61.41.87.71a2.34,2.34,0,0,1,.8,1.69,1.63,1.63,0,0,1-1.76,1.53c-.59,0-1.18,0-1.77,0H40.7c-.13,0-.26,0-.38,0a1.68,1.68,0,0,1-1.63-.91,1.78,1.78,0,0,1,.3-1.91,2.86,2.86,0,0,1,1.06-.89c.13-.07.31-.1.12-.29a7.21,7.21,0,0,1-1.66-3.82,10.61,10.61,0,0,1,1.18-7.91,8.44,8.44,0,0,1,5.48-3.74c.44-.11.54-.29.5-.69a1.14,1.14,0,0,1,.07-.68.46.46,0,0,1,.17.43c0,.53.23.56.66.51a23,23,0,0,1,5.11,0c.41.05.62,0,.59-.49a.85.85,0,0,1,.07-.47c.28-.19.32.08.3.21-.12.84.42,1,1.07,1.21A8.6,8.6,0,0,1,60,41.14a12.75,12.75,0,0,1-.63,5.91A2.14,2.14,0,0,1,58.76,48.12Z",
    style: {
      fill: "#f5d79b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.94,30.93a6.77,6.77,0,0,1-2.17-1.78A5.75,5.75,0,0,1,43.86,27c-.07-.33.12-.49.36-.44,1.18.27,1.94-.41,2.74-1.1a3.57,3.57,0,0,1,2.13-.77.75.75,0,0,1,.67,0,4.79,4.79,0,0,1,2.31,1.29,1.42,1.42,0,0,0,1.34.47,1.21,1.21,0,0,1,.38,0c.58,0,.77.27.64.85a5.14,5.14,0,0,1-3.34,3.82c-1.22.08-2.44,0-3.66,0A.6.6,0,0,1,46.94,30.93Z",
    style: {
      fill: "#f5d79b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.25,30.93a1.39,1.39,0,0,1,1.2,1.18,2.45,2.45,0,0,0,0,.27c0,1.09,0,1-1.1.91a19.44,19.44,0,0,0-4.38,0,4.59,4.59,0,0,0-.9.1c-.2.07-.28-.06-.29-.26s0-.61,0-.91a1.39,1.39,0,0,1,1.2-1.28Z",
    style: {
      fill: "#fbb03b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.23,40.13c0,.53.4.89,1.12.91a2.33,2.33,0,0,1,2.32,1.76,2.3,2.3,0,0,1-1.28,2.61c-.31.13-.47.25-.45.61a.57.57,0,0,1-.61.66.61.61,0,0,1-.66-.68.59.59,0,0,0-.41-.66,1.83,1.83,0,0,1-1-1,.59.59,0,0,1,.23-.87.6.6,0,0,1,.91.26,1,1,0,0,0,1.07.63,1.1,1.1,0,0,0,1-1,1,1,0,0,0-1.09-1A2.25,2.25,0,0,1,47.16,41a2.22,2.22,0,0,1,1-3c.33-.16.56-.3.54-.74a.6.6,0,0,1,.63-.6.59.59,0,0,1,.63.61.7.7,0,0,0,.54.79,1.94,1.94,0,0,1,.87.92.62.62,0,0,1-.3.94c-.37.2-.63.05-.84-.3-.32-.56-.66-.71-1.17-.57A1,1,0,0,0,48.23,40.13Z",
    style: {
      fill: "#fbb03b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.55,19.6a11.8,11.8,0,0,0,3-2.13,6.47,6.47,0,0,0,1.86-4.68c0-1.12,0-2.24,0-3.36a.73.73,0,0,0-.59-.83L13.25,7.07A1.61,1.61,0,0,0,12.77,7a2.38,2.38,0,0,0-.37,0L7.58,8.64a.69.69,0,0,0-.52.74c0,1.22,0,2.44,0,3.67a6,6,0,0,0,1,3.4,9.7,9.7,0,0,0,3.44,3.08,2.58,2.58,0,0,0,1,.45A4.24,4.24,0,0,0,13.55,19.6Z",
    style: {
      fill: "#5e80e6"
    }
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTxnClaimV1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Txn_Claim_v1.03bba9f7.svg";
export { ForwardRef as ReactComponent };